export default __webpack_public_path__ + "static/media/dtsu5168_ct_gw152.cb4c6712.jpg";